import React, { useState } from 'react';
import { theme } from '../../../../style/global-style';
import { eventTracker } from '../../../../utils/EventTracker';
import { log } from '../../../../utils/logger';
import { __ } from '../../../../utils/translation-service';
import { DreamlinesButton } from '../../../atoms/dreamlines-button/dreamlines-button';
import { post } from '../../header/header-mobile-old/http';
import { AttentionIcon } from '../../header/header-mobile-old/Icons/AttentionIcon';
import { CheckMarkIcon } from '../../header/header-mobile-old/Icons/CheckMarkIcon';
import { CrossIcon } from '../../header/header-mobile-old/Icons/CrossIcon';
import { NewsletterIcon } from '../../header/header-mobile-old/Icons/NewsletterIcon';
import * as Colors from '../../header/header-mobile-old/variables';
import { readCookie, setNewsletterSubmitCookie } from '../footer-desktop-old/cookie';
import { LoadingIndicator } from '../footer-mobile-old/LoadingIndicator/LoadingIndicator';
import { validateEmail } from '../footer-mobile-old/regExpHelpers';
import {
    StyledComponentWrapper,
    StyledEmailWrapper,
    StyledError,
    StyledGDRPTextStyle,
    StyledHeaderText,
    StyledText,
} from './NewsletterFooter.style';

const style: any = {
    wrapper: {
        position: 'relative',
        background:
            'url(https://website-production-public.dreamlines.de/mobile/d1c6f1f70c/assets/images/common/faq_contact_background.jpg) no-repeat',
        backgroundSize: 'cover',
        padding: '15px 15px 7px 15px',
        minHeight: '180px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    overlay: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        backgroundColor: 'rgba(11, 78, 128, 0.65)',
    },
    icon: {
        fill: Colors.white,
    },
    formWrapper: {
        display: 'flex',
    },
    iconWrapper: {
        marginRight: 12,
        flex: '0 0 auto',
        marginTop: 20,
    },
    input: {
        lineHeight: '20px',
        fontSize: 15,
        padding: 9,
        outline: 'none',
        border: `1px solid ${Colors.transparent}`,
        width: '100%',
        color: 'rgb(42, 42, 42)',
    },
    buttonWrapper: {
        height: '40px',
        width: '100%',
        fontSize: theme.fontSize.copyTextL,
        marginLeft: 7,
        padding: '6px 33px',
        marginTop: 15,
        fontWeight: 600,
        cursor: 'pointer',
    },
    attentionIcon: {
        fill: Colors.white,
        marginRight: 5,
    },
    loadingIndicator: {
        position: 'absolute',
        textAlign: 'center',
        fontSize: '3px',
        margin: '18px 18px 18px auto',
    },
    thankYouWrapper: {
        display: 'flex',
        zIndex: 9,
        maxWidth: '608px',
    },
    checkMarkIcon: {
        flex: '0 0 auto',
        marginRight: 10,
        fill: Colors.white,
        alignSelf: 'flex-start',
    },
    crossIcon: {
        fill: Colors.white,
        position: 'absolute',
        top: 10,
        right: 10,
        cursor: 'pointer',
    },
    confirmEmailWrapper: {
        color: Colors.white,
        fontSize: 17,
        flex: '1 1 auto',
        lineHeight: '20px',
    },
    confirmText: {
        fontSize: 17,
        color: Colors.white,
    },
    confirmEmailText: {
        marginTop: 20,
        fontSize: 15,
        color: Colors.white,
    },
    textCenter: {
        textAlign: 'center',
    },
};

interface IProps {
    type: string;
    deviceType: string;
    testSelectorName?: string;
}

export const NewsletterFooter = (props: IProps) => {
    const [hide, setHide] = useState(true);
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isSignUpSuccessful, setIsSignUpSuccessful] = useState(false);
    const [isError, setIsError] = useState(false);

    React.useEffect(() => {
        setHide(Boolean(readCookie('DLhasLead')));
    }, []);

    const onEmailChanged = (e: any) => {
        setIsError(isError ? !validateEmail(e.target.value) : false);
        setEmail(e.target.value);
    };

    const onCloseHandler = () => {
        setHide(true);
    };

    const handleSubmitClick = () => {
        if (validateEmail(email)) {
            setIsLoading(true);

            const config = {
                headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
            };
            const formData = `action=newsletter&email=${encodeURIComponent(email)}&headerTitle=`;

            post(
                `/wp-content/themes/dreamlines/ajax/ajaxhandler.php`,
                formData,
                //@ts-ignore
                config,
            )
                //@ts-ignore
                .then((response) => {
                    setNewsletterSubmitCookie();
                    setIsSignUpSuccessful(true);
                    setIsLoading(false);
                    eventTracker.track({
                        event: 'click',
                        action: 'footer-signup',
                        category: 'newsletter',
                        label: `${props.type}page`,
                    });
                })
                .then(() => {
                    // UserIdentification.setCustomer(email);
                })
                .catch((error) => {
                    setIsSignUpSuccessful(false);
                    setIsLoading(false);
                    log.error('Handling submit in newsletter footer ', error);
                });
        } else {
            setIsError(true);
            setIsLoading(false);
        }
    };

    const getNewsletterIcon = () => {
        return (
            <div style={{ ...style.iconWrapper }}>
                <NewsletterIcon width={30} height={30} style={style.icon} />
            </div>
        );
    };

    const inputFieldStyles: any = isError
        ? {
              ...style.input,
              ...{
                  borderColor: Colors.pink,
              },
          }
        : { ...style.input };
    const excludeArrow = props.deviceType === 'mobile';

    if (hide) {
        return null;
    }

    return (
        <div style={{ ...style.wrapper }}>
            <div style={style.overlay} />
            {!isSignUpSuccessful && (
                <StyledComponentWrapper>
                    <StyledHeaderText role="presentation">
                        <StyledText> {__('subscribeAndGetOnboardCredit')}</StyledText>
                    </StyledHeaderText>
                    <>
                        <div style={{ ...style.formWrapper }}>
                            {props.deviceType !== 'mobile' && getNewsletterIcon()}
                            <StyledEmailWrapper>
                                <LoadingIndicator
                                    isLoading={isLoading}
                                    style={style.loadingIndicator}
                                />
                                <input
                                    type="email"
                                    placeholder={__('yourEmailAddress')}
                                    value={email}
                                    onChange={onEmailChanged}
                                    style={inputFieldStyles}
                                />
                            </StyledEmailWrapper>
                            <DreamlinesButton
                                style={style.buttonWrapper}
                                primary
                                onClick={handleSubmitClick}
                                excludeArrow={excludeArrow}
                            >
                                {__('send')}
                            </DreamlinesButton>
                        </div>
                        {isError && (
                            <StyledError>
                                {/* added empty object to fix missing values in type */}
                                <AttentionIcon width={16} height={16} style={style.attentionIcon} />
                                {__('incorrectEmail')}
                            </StyledError>
                        )}
                        <StyledGDRPTextStyle
                            className={'GDPRContent'}
                            dangerouslySetInnerHTML={{
                                __html: __('newsletterRelatedGDPRText'),
                            }}
                        />
                    </>
                </StyledComponentWrapper>
            )}

            {isSignUpSuccessful && (
                <div style={style.thankYouWrapper}>
                    {/* added empty object to fix missing values in type  */}
                    <CheckMarkIcon style={style.checkMarkIcon} {...({} as any)} />
                    <div style={style.confirme}>
                        <div style={style.confirmText}>
                            {__('successfulNewsletterSubscription')}
                        </div>
                        <div style={style.confirmEmailText}>{__('verifyYourEmailAddress')}</div>
                    </div>
                    <div style={style.crossIcon} onClick={onCloseHandler} role="presentation">
                        {/* added empty object to fix missing values in type  */}
                        <CrossIcon {...({} as any)} />
                    </div>
                </div>
            )}
        </div>
    );
};
